export enum MediaType {
    Image = 0,
    Video = 1
}

export type MediaFileDimensions = {
    width: number;
    height: number;
};

export type MediaFile = {
    id: number;
    filename: string;
    type: MediaType;
    user_id: number;
    space_id: number;
    is_premium: boolean;
    is_system_media: boolean;
    category_id: number | null;
    width: number;
    height: number;
    title: string;
    description: string | null;
    uploaded_time: number;
    dimensions: MediaFileDimensions | null;
    thumbnail_filename: string;
    thumbnail_dimensions: MediaFileDimensions | null;
    full_filename: string;
    relative_filename: string | null;
    preview_image: string | null;
    is_external_stock: boolean;
    original_url: string | null;
    archived: boolean;
};
